<template>
  <MySearch ref="search" :selectFiles="selection">
    <Button type="primary" @click="handleToName">修改查档信息登记</Button>
  </MySearch>
</template>

<script>
import MySearch from '../search'
export default {
  name: 'modifySearch',
  components: { MySearch },
  data () {
    return {
      selection: []
    }
  },
  methods: {
    handleToName () {
      this.$refs['search'].handleToName('modify-register')
    }
  }
}
</script>
